export class DartfishNotebookProperties {
  public Name: string;
  public Position: number;
  public Duration: number;
  public Period: string;
  public Action: string;
  public ColorTag: string;
}
